import cn from 'classnames';

import { IConDefaultType } from '../types';

interface IUpLoadPhotoIconProps extends IConDefaultType {}

function UpLoadPhotoIcon({ className, size = 20, rotate, flip }: IUpLoadPhotoIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="8" fill="#ADB0B8" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7599 8.21031C13.7599 8.00722 13.5938 7.84258 13.3889 7.84258C13.184 7.84258 13.0179 8.00722 13.0179 8.21031C13.0179 8.4134 13.184 8.57804 13.3889 8.57804C13.5938 8.57804 13.7599 8.4134 13.7599 8.21031ZM12.3072 10.1836C12.3072 9.875 12.2461 9.57544 12.1257 9.29327C12.0095 9.02088 11.8432 8.77631 11.6314 8.56637C11.4196 8.35643 11.1728 8.19156 10.898 8.07635C10.6134 7.957 10.3111 7.89648 9.99979 7.89648C9.68843 7.89648 9.38622 7.957 9.10154 8.07635C8.82674 8.19156 8.58001 8.35643 8.36821 8.56637C8.1564 8.77631 7.99007 9.02088 7.87384 9.29327C7.75343 9.57545 7.69238 9.875 7.69238 10.1836C7.69238 10.4922 7.75343 10.7918 7.87384 11.074C7.99007 11.3464 8.1564 11.5909 8.36821 11.8009C8.58001 12.0108 8.82674 12.1757 9.10154 12.2909C9.38622 12.4103 9.68843 12.4708 9.99979 12.4708C10.3111 12.4708 10.6134 12.4103 10.898 12.2909C11.1728 12.1757 11.4196 12.0108 11.6314 11.8009C11.8432 11.5909 12.0095 11.3464 12.1257 11.074C12.2461 10.7918 12.3072 10.4922 12.3072 10.1836ZM14.6668 12.995C14.6668 13.291 14.4226 13.5331 14.124 13.5331H5.87631C5.57777 13.5331 5.3335 13.291 5.3335 12.995V7.68275C5.3335 7.38683 5.57777 7.1447 5.87631 7.1447H5.98292C6.02259 6.96807 6.18159 6.836 6.37174 6.836H6.89321C7.08336 6.836 7.24236 6.96807 7.28202 7.1447H7.78741L8.20701 6.41907C8.33313 6.20095 8.56738 6.06641 8.82101 6.06641H11.1822C11.4359 6.06641 11.6701 6.20095 11.7963 6.41907L12.2158 7.1447H14.124C14.4226 7.1447 14.6668 7.38683 14.6668 7.68275V12.995ZM11.6584 10.1828C11.6584 11.0891 10.9145 11.8265 10.0001 11.8265C9.0857 11.8265 8.3418 11.0891 8.3418 10.1828C8.3418 9.27643 9.0857 8.53906 10.0001 8.53906C10.9145 8.53906 11.6584 9.27643 11.6584 10.1828Z"
          fill="white"
        />
      </svg>
    </i>
  );
}

export default UpLoadPhotoIcon;
